import * as React from 'react';
import { Heading2 } from "../../../../elements";
import { FormattedMessage } from '../ReadReportGuideModal';
import InfoIcon from "@material-ui/icons/Info";
export const DiscrepancyManagement = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Heading2, null,
            React.createElement(FormattedMessage, { id: 'readreport.guidemodal.discrepancy_management.title' })),
        React.createElement("section", { className: "ImageWithParagraph" },
            React.createElement(InfoIcon, null),
            React.createElement("article", null,
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: 'readreport.guidemodal.discrepancy_management.paragraph1' })),
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: 'readreport.guidemodal.discrepancy_management.paragraph2' })),
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: 'readreport.guidemodal.discrepancy_management.paragraph3' }))))));
};
